import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { ConfigProvider } from 'antd'
import enUS from 'antd/locale/en_US'
import esES from 'antd/locale/es_ES'
import { useGeckoLocale } from 'features/locale/GeckoLocaleProvider'
import React from 'react'

/**
 * Feeds the current language to Lingui and antd. Must render inside
 * GeckoLocaleProvider, and above anything that renders translated copy.
 */
export const LocaleUiProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { language } = useGeckoLocale()

  return (
    <I18nProvider i18n={i18n}>
      <ConfigProvider locale={language === 'es' ? esES : enUS}>
        {children}
      </ConfigProvider>
    </I18nProvider>
  )
}
